import * as React from 'react';
import IspSortOPtion from './isp_sort_option';

/**
 *
 * IspSerpSorting component
 * @extends {React.PureComponent<IIspSerpProps<IIspSerpData>>}
 */
class IspSerpSorting extends React.Component {
    public render(): JSX.Element | null {
        /* tslint:disable:no-string-literal */
        function localToggleDropdownSort2():boolean {
            if (window['toggleDropdownSort2'] !== undefined) {
                return window['toggleDropdownSort2']();
            }
            return false;
        }
        /* tslint:enable:no-string-literal */
        return (
            <>
                <ul id='isp_search_res_sorting_menu'>
                            <li id='search_res_sorting_title'>Sort by:</li>
                            <li
                                role='button'
                                id='isp_sorting_drop_container'
                                style={{display: 'inline-block'}}
                                onClick={localToggleDropdownSort2}
                                className='isp_dropdown'
                            >
                                <a
                                    role='button'
                                    className='dropdown-toggle-isp'
                                    data-toggle='dropdown-isp'
                                    aria-label='Toggle sort dropdown'
                                >
                                        <span id='sorting_chosen_name'>Best Match</span>
                                        <b className='caret'/>
                                </a>
                                <ul id='sorting_drop_list' className='dropdown-menu' role='menu'>
                                    <IspSortOPtion
                                        id='isp_sort_best_match'
                                        title='Best Match'
                                        label='Sort results by best match'
                                        text='Best Match'
                                    />
                                    <IspSortOPtion
                                        id='isp_sort_price_low_to_high'
                                        title='Price: Low to High'
                                        label='Sort results by lowest to highest price'
                                        text='Price: Low to High'
                                    />
                                    <IspSortOPtion
                                        id='isp_sort_price_high_to_low'
                                        title='Price: High to Low'
                                        label='Sort results by highest to lowest price'
                                        text='Price: High to Low'
                                    />
                                    <IspSortOPtion
                                        id='isp_sort_newest_arrival'
                                        title='Newest Arrivals'
                                        label='Sort results by newest arrivals'
                                        text='Newest Arrivals'
                                    />
                                    <IspSortOPtion
                                        id='isp_sort_oldest'
                                        title='Oldest Products'
                                        label='Sort results by oldest products'
                                        text='Oldest Products'
                                    />
                                </ul>
                            </li>
                        </ul>
            </>
        );
    }
}
export default IspSerpSorting;
